<template>
  <div class="contain">
    <div class="title">实名认证</div>
    <div>
      <div class="uploadImg">
        <p>上传身份证正面<b>*</b></p>
        <div class="avatar-uploader ">
          <div class="changeFilesBtns" v-if="paramP.identityPositiveUrl==''" style="position: relative;">
            <input type="file" class="changeFiles" name="" id="" value="文件上传" @change="changeFiles" />
            <label for=""></label>
          </div>
          <div v-else class="imgMuchang">
            <div class="del" @click="delImgs">
              <img src="../assets/img/closeW.png">
            </div>
            <img :src="paramP.identityPositiveUrl">
          </div>
        </div>
      </div>
      <div class="uploadImg">
        <p>上传身份证反面<b>*</b></p>
        <div class="avatar-uploader ">
          <div class="changeFilesBtn" v-if="paramP.identityAntiUrl==''" style="position: relative;">
            <input type="file" class="changeFiles" name="" id="" value="文件上传" @change="changeFile" />
            <label for=""></label>
          </div>
          <div v-else class="imgMuchang">
            <div class="del" @click="delImg">
              <img src="../assets/img/closeW.png">
            </div>
            <img :src="paramP.identityAntiUrl">
          </div>
        </div>
      </div>
    </div>
    <div class="submit" @click="submit">提交</div>
  </div>

</template>
<script type="text/ecmascript-6">
  import Vue from 'vue'
  import {
    uploadFile,
    sendCodeApi,
    registerApi,
    accountSmsLoginApi,
    autoInfo
  } from '@/api/index'
  import {

    accountLogin,

  } from '@/api/login'
  export default {
    name: 'login',
    data() {
      return {
        paramP: {
          identityAntiUrl: '', //fan
          identityPositiveUrl: ''
        }

      }
    },
    // 创建完毕状态(里面是操作)
    created() {


    },
    // 里面的函数只有调用才会执行
    methods: {
      delImg() {
        this.paramP.identityAntiUrl = ''
      },
      delImgs() {
        this.paramP.identityPositiveUrl = ''
      },
      changeFile(e) {
        console.log(e)
        let filea = e.target.files[0];
        let file = new FormData();
        file.append("file", filea);
        // file.append("deptId", this.xzItem.deptId);
        //   file.append("optAuthType", this.info.optAuthType);
        // this.fileDate.file = formFiles
        uploadFile(file)
          .then(res => {
            if (res.data.code == 0) {
              this.paramP.identityAntiUrl = res.data.data
              console.log(res)
              // res.data.data.forEach(item=>{
              //   Vue.set(item,'checked',false)
              // })
              // _this.options = res.data.data
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })

      },
      changeFiles(e) {
        console.log(e)
        let filea = e.target.files[0];
        let file = new FormData();
        file.append("file", filea);
        // file.append("deptId", this.xzItem.deptId);
        //   file.append("optAuthType", this.info.optAuthType);
        // this.fileDate.file = formFiles
        uploadFile(file)
          .then(res => {
            if (res.data.code == 0) {
              this.paramP.identityPositiveUrl = res.data.data
              console.log(res)
              // res.data.data.forEach(item=>{
              //   Vue.set(item,'checked',false)
              // })
              // _this.options = res.data.data
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })

      },
      submit() {
        var _this = this
        if (_this.paramP.identityAntiUrl == '') {
          alert('请上传身份证反面照片')
        } else if (_this.paramP.identityPositiveUrl == '') {
          alert('请上传身份证正面照片')
        } else {
          autoInfo(_this.paramP).then(response => {
            console.log(response)
            _this.logining = false
            localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('userPhone', this.userAccount)
            localStorage.setItem('userInfo', JSON.stringify(response.data.data))
            // _this.$store.commit('login', res.data)
            console.log(_this.$store)
            _this.$router.push({
              path: '/index'
            })
            // this.algoList = response.data.data.records

          })
        }
      },

    }
  }
</script>
<style scoped="scoped">
  .contain {
    background: #fff;
    width: 100%;
    height: 100vh;
  }

  .title {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    padding: 30px 0;

  }

  .uploadImg {
    display:block;
    width: 360px;
    min-height: 200px;
    margin: 0 auto;
  }

  .uploadImg p,
  .maskBoxss ul li label {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
    display: block;
  }

  .uploadImg p b,
  .maskBoxss ul li label i {
    font-weight: normal;
    color: #D92121;
    margin-left: 5px;
    font-style: normal;
  }

  .avatar-uploader {
    width: 360px;
    height: 200px;
    position: relative;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 5px;
  }

  .avatar-uploader .imgMuchang {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .avatar-uploader .imgMuchang img {
    max-width: 100%;
    height: 200px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    bottom: 0;
  }

  .imgMuchang .del {
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 40px;
    z-index: 99999;
    cursor: pointer;
    background: rgba(0, 0, 0, .5);

  }

  .imgMuchang .del>img {
    margin: 7px;
    width: 26px;
    height: 26px;
  }

  .changeFilesBtns {
    background: url(../assets/img/u2035.png) no-repeat center;
    background-size: 360px 200px;
    border: none;
    width: 360px;
    height: 200px;
    margin: 0 !important;
    padding: 0;
    border: none !important;
  }

  .changeFilesBtn {
    background: url(../assets/img/u2034.png) no-repeat center;
    background-size: 360px 200px;
    border: none;
    width: 360px;
    height: 200px;
    margin: 0 !important;
    padding: 0;
    border: none !important;
  }

  .changeFiles {
    cursor: pointer;
    position: absolute;
    width: 360px;
    height: 200px;
    left: 0;
    top: 0;
    opacity: 0;
  }

  .submit {
    width: 400px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    background: #30bf30;
    margin: 30px auto;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/autoInfo.vue